import { z } from 'zod'

import { DEFAULT_LIMIT } from '@/components/ui/pagination/pagination.constants'

export const GIFT_CARDS_TABLE_ID = 'gift-cards-table'

// Note: '' (not undefined) means "all" for category/status/type - matches the legacy
// `getGiftCardsTabs`/`getGiftCardCategoryFilterOptions`/`getGiftCardStatuses` option shape
// (helpers.jsx), where the "All ..." option's own `value` is `''`.
export const giftCardsFiltersSchema = z.object({
  category: z.string().optional(),
  clientId: z.array(z.coerce.number()).optional(),
  limit: z.coerce.number().optional(),
  search: z.string().optional(),
  skip: z.coerce.number().optional(),
  status: z.string().optional(),
  type: z.string().optional(),
})

export type GiftCardsFilters = z.infer<typeof giftCardsFiltersSchema>

export const initialGiftCardsFilters: GiftCardsFilters = {
  category: '',
  clientId: [],
  limit: DEFAULT_LIMIT,
  search: '',
  skip: 0,
  status: '',
  type: '',
}
